<div fxLayout="column" style="width: 50vw; height: 50vh">
    <div class="mat-dialog-title" mat-dialog-title fxLayoutAlign="space-between">
        <h2>{{'textEditor' | translate}}</h2>
        <mat-icon class="clear-button" [svgIcon]="'delete'" (click)="clearClose()" matTooltip="{{'clear' | translate}}"></mat-icon>
    </div>

    <mat-dialog-content fxFlex id="editor-container">
        <p-editor #editor [style]="{'font-size': '1rem', 'height': editorHeight, 'min-height': '50px'}"
            [(ngModel)]="htmlOutput" spellcheck="true"></p-editor>
    </mat-dialog-content>

    <mat-dialog-actions fxLayoutAlign="end" class="pt-4 pb-4">
        <button mat-button mat-raised-button mat-dialog-close (click)="close()" color="sims">{{'close' | translate}}</button>
        <button mat-button mat-raised-button color="sims" (click)="submit()">{{'submit' | translate}}</button>
    </mat-dialog-actions>
</div>